import { IonIcon } from "@ionic/react";
import { arrowDown, arrowUp } from "ionicons/icons";

interface DashboardRowProps {
  formatter: Intl.NumberFormat;
  isNegative?: boolean;
  movementAmount?: number;
  title: string;
  value: number;
}

export function DashboardRow({ formatter, isNegative = false, movementAmount, title, value }: DashboardRowProps) {
  return (
    <div className="dashboard-row">
      <span>{title}</span>
      <strong className={isNegative ? "negative" : ""}>{formatter.format(value)}</strong>
      {movementAmount && Math.abs(movementAmount) > 0.004 ? (
        <em className={movementAmount > 0 ? "movement-up" : "movement-down"}>
          <IonIcon icon={movementAmount > 0 ? arrowUp : arrowDown} />
          {formatter.format(Math.abs(movementAmount))}
        </em>
      ) : null}
    </div>
  );
}
